module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"book-sorting:title":"Отображать столбцы","book-sorting:apply-all":"Включить все","book-sorting:clear-all":"Отключить все"},"en":{"book-sorting:title":"Display сolumns","book-sorting:apply-all":"Apply all","book-sorting:clear-all":"Clear all"}}')
  delete Component.options._Ctor
}
